import React from 'react'
import './about.css'
import ME from '../../assests/Me1.png'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {AiOutlineFundProjectionScreen} from 'react-icons/ai'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="AboutImage" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon"/>
              <h5>Experience</h5>
              <small>6+ Years</small>
            </article>
            <article className="about__card">
              <FiUsers className="about__icon"/>
              <h5>Clients</h5>
              <small>20+</small>
            </article>
            <article className="about__card">
              <AiOutlineFundProjectionScreen className="about__icon"/>
              <h5>Projects</h5>
              <small>60+ Completed</small>
            </article>
          </div>
           <p className='para'>
           I build complex Linux-based systems and C++ software that bridges hardware and software seamlessly, delivering robust, high-performance solutions for real-world embedded applications. My work focuses on system architecture, hardware integration, and reliable engineering, turning challenging problems into elegant, maintainable solutions.
           </p>
           <p className='para'>
            A Computer Science graduate from FAST-NUCES, and former Google Developer Student Clubs Lead (2022–2023), where I had the privilege to lead projects and represent my university in a global developer community.
           </p>
           <p className='para'>
            I love exploring technology, engineering challenges, and ideas that make a real impact, while also learning, reading, and reflecting on life along the way.
           </p>
           <p className='para'>
           Will be happy to connect with you!
           </p>
           <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About